import React from 'react';
import { Box } from '@mui/material';

/**
 * Reusable logo component for the sidebar
 * @param {Object} props - Component props
 * @param {string} [props.src] - Logo image source
 * @param {string} [props.alt] - Alt text for the logo
 * @param {string} [props.className] - Additional CSS classes
 * @param {Object} [props.style] - Inline styles
 */
const SidebarLogo = ({
  src = '/images/SV_Class_Edge.png',
  alt = 'Logo',
  className = '',
  style = {},
}) => {
  return (
    <Box
      className={`flex justify-center items-center ${className}`}
      style={style}
    >
      <img
        src={src}
        alt={alt}
        className='h-auto max-h-[55px] max-w-full object-contain'
      />
    </Box>
  );
};

export default SidebarLogo;
